module.exports = __webpack_public_path__ + "static/media/image16.678460c8.png";